import React from 'react';
import { TextFieldElement } from 'react-hook-form-mui';
import * as yup from 'yup';

export const keyContactsSchema = {
  behaviorEscalationContact: yup.string(),
  fosterContact: yup.string(),
  adopterContact: yup.string(),
  preSurrenderContact: yup.string(),
};

export const KEY_CONTACT_FIELDS = [
  {
    name: 'behaviorEscalationContact',
    label: 'Behavior escalation',
    helperText: 'Primary contact at the organization for behavior escalations.',
  },
  {
    name: 'fosterContact',
    label: 'Foster',
    helperText: 'Primary escalation contact at the organization for foster questions or concerns.',
  },
  {
    name: 'adopterContact',
    label: 'Adopter',
    helperText: 'Primary escalation contact at the organization for adopter questions or concerns.',
  },
  {
    name: 'preSurrenderContact',
    label: 'Pre-surrender',
    helperText: 'Primary escalation contact at the organization for pre-surrender questions or concerns.',
  },
] as const;

function KeyContactPartial(
  {
    name, label, helperText, minRows = 1,
  }:
    {
      name: string, label: string, helperText: string, minRows?: number,
    },
) {
  return (
    <TextFieldElement
      name={name}
      sx={{ marginTop: 2 }}
      fullWidth
      multiline
      minRows={minRows}
      label={label}
      helperText={helperText}
      variant="outlined"
      InputLabelProps={{ shrink: true }}
    />
  );
}
export default KeyContactPartial;
